export default __webpack_public_path__ + "static/matthew-62b6743cbb7d0704ac42a7d89def32af.jpg";